import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";

// Reducers
import authReducer from "./Slices/authSlice";
import mainReducer from "./Slices/mainSlice";
import contentManagementReducer from "./Slices/contentManagementSlice";
import userManagementReducer from "./Slices/userManagementSlice";
import productCatalogReducer from "./Slices/productCatalogSlice";
import companyManagementReducer from "./Slices/companyManagementSlice";
import requestManagementReducer from "./Slices/requestManagementSlice";
import dashboardReducer from "./Slices/dashboardSlice";
import contactManagementReducer from "./Slices/contactManagementSlice";
import countryReducer from "./Slices/countrySlice";

import persistConfig from "./persistConfig";
import failureAnalysisReqReducer from "./Slices/failureAnalysisReqSlice";
import { countryDataMiddleware } from "Services/Utils/countryDataMiddleware";

// Configure persisted reducers
const persistedAuthReducer = persistReducer(persistConfig, authReducer);
const persistedMainReducer = persistReducer(persistConfig, mainReducer);
const persistedContentManagementReducer = persistReducer(
  persistConfig,
  contentManagementReducer
);
const persistedUserManagementReducer = persistReducer(
  persistConfig,
  userManagementReducer
);
const persistedProductCatalogReducer = persistReducer(
  persistConfig,
  productCatalogReducer
);
const persistedCompanyManagementReducer = persistReducer(
  persistConfig,
  companyManagementReducer
);
const persistedFailureAnalysisReqReducer = persistReducer(
  persistConfig,
  failureAnalysisReqReducer
);
const persistedRequestManagementReducer = persistReducer(
  persistConfig,
  requestManagementReducer
);
const persistedDashboardReducer = persistReducer(
  persistConfig,
  dashboardReducer
);
const persistedContactManagementReducer = persistReducer(
  persistConfig,
  contactManagementReducer
);

// Create the Redux store
const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    main: persistedMainReducer,
    contentManagement: persistedContentManagementReducer,
    userManagement: persistedUserManagementReducer,
    productCatalog: persistedProductCatalogReducer,
    companyManagement: persistedCompanyManagementReducer,
    failureAnalysisRequest: persistedFailureAnalysisReqReducer,
    requestManagement: persistedRequestManagementReducer,
    dashboard: persistedDashboardReducer,
    contactManagement: persistedContactManagementReducer,
    countries: countryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check if needed
    }).concat(countryDataMiddleware),
});

const persistor = persistStore(store);

// Exporting store and persistor
export default store;
export { persistor };
